import { Box, Container, Link, Stack, Typography, useTheme } from '@mui/joy';
import { LogoText } from '../../../components/module/Logo/Logo';
import { useMediaQuery } from '@mui/material';

const ACCENT_COLOR_LIGHT = '#0ABAB5';
const ACCENT_COLOR_DARK = '#fff';

export function FooterSection() {
    const theme = useTheme();
    const isDark = theme.colorSchemes?.dark && theme.palette.mode === 'dark';
    const isMobile = useMediaQuery('(max-width:899px)');
    const isNarrow = useMediaQuery('(max-width:430px)');

    return (
        <Box component="footer" sx={{ borderTop: '1px solid', borderColor: 'divider', py: 4 }}>
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Link href="/">
                            <LogoText
                                color={theme.colors.logo}
                                colorText={theme.palette.text.primary}
                                width={isMobile ? '120' : '140'}
                                height="auto"
                            />
                        </Link>
                    </Stack>
                    <Stack direction={isNarrow ? 'column' : 'row'} spacing={isNarrow ? 1 : 3} alignItems="center">
                        <Link href="/legal/terms-of-service" target="_blank" level="body-sm" color="neutral" sx={{ textAlign: 'center' }}>Условия использования</Link>
                        <Link href="/legal/privacy" target="_blank" level="body-sm" color="neutral" sx={{ textAlign: 'center' }}>Конфиденциальность</Link>
                        <Link href="/faq" target="_blank" level="body-sm" color="neutral" sx={{ textAlign: 'center' }}>FAQ</Link>
                    </Stack>
                    <Typography level="body-sm" sx={{ color: 'text.tertiary' }}>
                        © {new Date().getFullYear()} Аквариум
                    </Typography>
                </Stack>
            </Container>
        </Box>
    );
}
